export default __webpack_public_path__ + "static/media/hall_of_fame_three.2b730afe.png";